import Body from "./Body";
import TimeFilter from "./TimeFilter";
import Approve from "./Approve";
import Block from "./Block";
import ShowInfo from './ShowInfo';

export const Components = {
  Body,
  TimeFilter,
  Approve,
  Block,
  ShowInfo,
};
